export default __webpack_public_path__ + "static/81498-63eb333bbb4b33712e6c1dc24f1c6612.jpg";